export default "__VITE_ASSET__C39xJoug__"